<template>
  <b-card style="position: relative">
    <div v-if="loading" class="loading_page">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
    </div>

    <b-form @submit.prevent="save">
      <b-row>
        <b-col cols="12">
          <rfid-form :rfid-data="request" :errors="errors"></rfid-form>
        </b-col>
        <b-col cols="12">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
            {{ $t('Save') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>

import { OrbitSpinner } from 'epic-spinners'
import { BButton, BCard, BCol, BForm, BFormGroup, BFormInput,
  BInputGroup, BRow, BAlert, BTabs, BTab, BCardText
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { onUnmounted, ref } from '@vue/composition-api'
import store from '@/store'
import RfidForm from '@/views/modules/rfid/components/Form'
import rfidStore from '@/app/rfid/rfidStoreModule'
import router from '@/router'

export default {
  name: 'CreateRfid',
  components: { RfidForm, BRow, BCard, BCol, BAlert,
    BFormGroup, BFormInput, BInputGroup, BForm, BButton, BTabs, BCardText, BTab, vSelect, OrbitSpinner
  },
  directives: { Ripple, },
  setup(props, { root}) {

    const RFID_STORE = 'rfid'
    store.registerModule(RFID_STORE, rfidStore)

    onUnmounted(() => {
      if (store.hasModule(RFID_STORE))
          store.unregisterModule(RFID_STORE)
    })

    const loading = ref(false)
    const errors = ref({})


    const request = ref({})

    store.dispatch('rfid/fetchRfid', router.currentRoute.params.id)
        .then(res => request.value = res.data.rfid)

    const save = () => {
      loading.value = true
      store.dispatch('rfid/updateRfid', {
        id: router.currentRoute.params.id, form: request.value }).then(res => {
        errors.value = {}
        root.$bvToast.toast(
            root.$i18n.t("rfid device updated successfully"), {
              title: `Success`,
              variant: 'success',
        })

      }).catch(e => {
        if (e.response.status === 422) {
          errors.value = e.response.data.errors
        }
      }).finally(() => loading.value = false)

    }


    return {
      loading,
      request,
      errors,
      save,
    }

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

</style>
